import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { Card, Col, Collapse, Row } from 'react-bootstrap-5';

import { ProjectPropTypes } from 'components/project/prop_types';
import MediaPhotoForm from 'bundles/project/components/media_tab/media_photo_form';
import VisualMediaForm from 'bundles/project/components/media_tab/visual_media_form';
import LeaseMediaLinks from 'bundles/project/components/media_tab/lease_spaces/lease_media_links';
import FloorPlan from 'components/floor_plan/floor_plan';

export default function LeaseSpaceRow({
  leaseData,
  leaseListing,
  index,
  syndication,
  visualMediaTypeOptions,
  onPhotoChange,
  onMediaLinksChange,
  onVisualMediaChange,
}) {
  const getLeaseMediaLinksValues = data => ({
    floorPlan: data.floorPlan,
    matterportUrl: data.matterportUrl || '',
    videoUrl: data.videoUrl || '',
    virtualTourUrl: data.virtualTourUrl || '',
  });

  const leaseStatusClass = leaseListing.leaseStatusLabel.toLowerCase().replaceAll(' ', '-');
  const [open, setOpen] = useState(false);
  const collapseId = `lease-space-${leaseListing.id}-details`;

  return (
    <Card className={`leaseSpace ${leaseStatusClass}`}>
      <Card.Header className="bg-body-tertiary">
        <button
          aria-controls={collapseId}
          aria-expanded={open}
          className="w-100 text-start border-0 bg-transparent p-0"
          type="button"
          onClick={() => setOpen(!open)}
        >
          <Row className="align-items-center g-2">
            <Col className="fw-bold" xs="auto">{leaseListing.address2Label}</Col>
            <Col>{leaseListing.spaceSizeLabel}</Col>
            <Col xs="auto">{leaseListing.leaseStatusLabel}</Col>
            <Col xs="auto"><FontAwesomeIcon icon={faChevronDown} rotation={open ? 180 : 0} /></Col>
          </Row>
        </button>
      </Card.Header>
      <Collapse in={open}>
        <div id={collapseId}>
          <Card.Body>
            <div className="form-vertical-field-container gap-4">
              <MediaPhotoForm
                basePhotoFormProps={leaseData.photoProps}
                bulkDownloadPhotosLink={leaseListing.bulkDownloadPhotosLink}
                name={`lease-photo-form-${leaseListing.id}`}
                photoEditorUrl={leaseData.photoProps.photoEditorUrl}
                photos={leaseData.photoProps.photoAttachments}
                showEdit={true}
                showLimit={true}
                syndication={syndication}
                onPhotoChange={newPhotos => onPhotoChange(newPhotos, leaseData.id)}
              />

              <div className="form-group">
                <label className="form-label">
                  Floor Plan
                  <span className="ms-1 text-muted small">(limit: 1)</span>
                </label>
                <FloorPlan
                  floorPlan={leaseData.floorPlan}
                  onChange={data => onMediaLinksChange('floorPlan', data, leaseData.id)}
                />
              </div>
              <VisualMediaForm
                embeds={leaseData.visualMediaEmbeds}
                parentName={`property[lease_spaces_attributes][${index}]`}
                visualMediaTypeOptions={visualMediaTypeOptions}
                onEmbedsChange={embeds => onVisualMediaChange(embeds, leaseData.id)}
              />
              <LeaseMediaLinks
                mediaLinksFormFields={getLeaseMediaLinksValues(leaseData)}
                onFormChange={(key, value) => onMediaLinksChange(key, value, leaseData.id)}
              />
            </div>
          </Card.Body>
        </div>
      </Collapse>

    </Card>
  );
}

LeaseSpaceRow.propTypes = {
  index: PropTypes.number.isRequired,
  leaseData: PropTypes.object.isRequired,
  leaseListing: PropTypes.object.isRequired,
  project: ProjectPropTypes.isRequired,
  syndication: PropTypes.bool.isRequired,
  visualMediaTypeOptions: PropTypes.array.isRequired,
  onMediaLinksChange: PropTypes.func.isRequired,
  onPhotoChange: PropTypes.func.isRequired,
  onVisualMediaChange: PropTypes.func.isRequired,
};
